import React from 'react';

const Legend = ({ label, color }: Props) => {
  return (
    <div className="badge bg-label-secondary text-secondary d-inline-flex mb-1 me-1 text-start align-items-center">
      <span className={`badge badge-dot bg-${color} me-1`}></span> {label}
    </div>
  );
}

interface Props {
  label: string,
  color: string
}

export { Legend };